export default __webpack_public_path__ + "static/media/Right004.1600d9ae.png";